<template>
  <div class="managingPeople hp100 bbox" v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row>
        <el-form>
          <el-col :span="4">
            <el-form-item label="支付方式：" label-width="100px">
              <el-select
                v-model="queryInfo.condition.payType"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="下单日期：" label-width="100px">
              <el-date-picker
                v-model="orderDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="getOrderDate"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" @click="search" class="ml10"
              >搜索</el-button
            >
          </el-col>
          <!-- 侧边信息 -->
          <div>
            <el-col :span="2" style="font-size:14px;">
              <span>支付宝：</span>
              <strong style="color:#ff463d">{{ topDate.aliCount }}</strong
              ><span>元;</span>
            </el-col>
            <el-col :span="2" style="font-size:14px">
              <span>微信：</span
              ><strong style="color:#ff463d">{{ topDate.weChatCount }}</strong
              ><span>元;</span>
            </el-col>
            <el-col :span="2" style="font-size:14px">
              <span>银行卡：</span
              ><strong style="color:#ff463d">{{ topDate.bankCount }}</strong
              ><span>元;</span>
            </el-col>
            <el-col :span="2" style="font-size:14px">
              <span>会员卡：</span
              ><strong style="color:#ff463d">{{
                topDate.memberCardCount
              }}</strong
              ><span>元;</span>
            </el-col>
            <el-col :span="2" style="font-size:14px">
              <span>现金：</span
              ><strong style="color:#ff463d">{{ topDate.cashierCount }}</strong
              ><span>元;</span>
            </el-col>
            <el-col :span="2" style="font-size:14px">
              <span>其他：</span
              ><strong style="color:#ff463d">{{ topDate.otherCount }}</strong
              ><span>元;</span>
            </el-col>
          </div>
        </el-form>
      </el-row>

      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }" style="margin-top: 20px">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%">
            <el-table
              :data="tableData"
              border
              fit
              highlight-current-row
              style="width: 100%"
              @sort-change="sortChange"
            >
              <!-- <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.id }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column label="商家编码" align="center"  prop="商家编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column label="商家名称" align="center" prop="商家名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.merchantName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="订单号" align="center" prop="订单号">
                <template slot-scope="scope">
                  <span>{{ scope.row.orderNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column label="流水号" align="center" prop="流水号">
                <template slot-scope="scope">
                  <span>{{ scope.row.transNo }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="桌台类型编码" align="center"  prop="桌台类型编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.tableTypeCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="桌台类型名称"
                align="center"
                prop="桌台类型名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.tableTypeName }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="桌台区域编码" align="center"  prop="桌台区域编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.tableAreaCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="桌台区域名称"
                align="center"
                prop="桌台区域名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.tableAreaName }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="桌台编码" align="center"  prop="桌台编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.tableCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column label="桌台名称" align="center" prop="桌台名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.tableName }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="会员编码" align="center"  prop="会员编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.memberCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column label="会员名称" align="center" prop="会员名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.memberName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="会员卡号" align="center" prop="会员卡号">
                <template slot-scope="scope">
                  <span>{{ scope.row.memberCardID }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="点单终端编码" align="center"  prop="点单终端编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.clientCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="点单终端名称"
                align="center"
                prop="点单终端名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.clientName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="用餐人数" align="center" prop="用餐人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.peopleCount }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="服务员编码" align="center"  prop="服务员编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.waiterCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="服务员名称"
                align="center"
                prop="服务员名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.waiterName }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="营销人员编码" align="center"  prop="营销人员编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.marketerCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="营销人员名称"
                align="center"
                prop="营销人员名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.marketerName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="开台时间" align="center" prop="开台时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.beginTime | dataFormat }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="开台人员编码" align="center"  prop="开台人员编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.beginUserCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="开台人员名称"
                align="center"
                prop="开台人员名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.beginUserName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="预结时间" align="center" prop="预结时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.yuJieTime | dataFormat }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="预结人员编码" align="center"  prop="预结人员编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.yuJieUserCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="预结人员名称"
                align="center"
                prop="预结人员名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.yuJieUserName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="是否结账" align="center" prop="是否结账">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.isCheckOut }}</span> -->
                  <span v-if="scope.row.isCheckOut == 0">未结账</span>
                  <span v-if="scope.row.isCheckOut == 1">已结账</span>
                  <span v-if="scope.row.isCheckOut == 3">反结账</span>
                </template>
              </el-table-column>
              <el-table-column label="是否找零" align="center" prop="是否找零">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.isZeroCheck }}</span> -->
                  <span v-if="scope.row.isZeroCheck == 1">已找零</span>
                  <span v-else>未找零</span>
                </template>
              </el-table-column>
              <el-table-column label="结账时间" align="center" prop="结账时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.checkOutTime | dataFormat }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="结账人编码" align="center"  prop="结账人编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.checkOutUserCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="结账人名称"
                align="center"
                prop="结账人名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.checkOutUserName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="折扣名称或者备注"
                align="center"
                prop="折扣名称或者备注"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.discountName }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="打折人员编码" align="center"  prop="打折人员编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.discountUserCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="打折人员名称"
                align="center"
                prop="打折人员名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.discountUserName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="订单原始金额"
                align="center"
                prop="订单原始金额"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.sumConsume }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="需要支付金额"
                align="center"
                prop="需要支付金额"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.sumToPay }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="已支付金额"
                align="center"
                prop="已支付金额"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.sumPaid }}</span>
                </template>
              </el-table-column>
              <el-table-column label="现金付款" align="center" prop="现金付款">
                <template slot-scope="scope">
                  <span>{{ scope.row.cashPaid }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="支付宝付款金额"
                align="center"
                prop="支付宝付款金额"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.aliPaid }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="微信付款金额"
                align="center"
                prop="微信付款金额"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.wechatPaid }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="信用卡付款金额"
                align="center"
                prop="信用卡付款金额"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.creditCardPaid }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="会员卡支付金额"
                align="center"
                prop="会员卡支付金额"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.memberCardPaid }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="支票付款金额"
                align="center"
                prop="支票付款金额"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.chequePaid }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="其他付款方式付款金额"
                align="center"
                prop="其他付款方式付款金额"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.otherPaid }}</span>
                </template>
              </el-table-column>
              <el-table-column label="赠送金额" align="center" prop="赠送金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.presentMoney }}</span>
                </template>
              </el-table-column>
              <el-table-column label="找零" align="center" prop="找零">
                <template slot-scope="scope">
                  <span>{{ scope.row.chargeFee }}</span>
                </template>
              </el-table-column>
              <el-table-column label="支付类型" align="center" prop="支付类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.payType == 'cashier'">现金</span>

                  <span v-if="scope.row.payType == 'memberCard'">会员卡</span>
                  <span v-if="scope.row.payType == 'bank'">银行卡</span>
                  <span v-if="scope.row.payType == 'wechat'">微信</span>
                  <span v-if="scope.row.payType == 'alipay'">支付宝</span>
                  <span v-if="scope.row.payType == ''">所有</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="支付类型编码" align="center"  prop="支付类型编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.payTypeName }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column label="开票金额" align="center" prop="开票金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.invoicePrice }}</span>
                </template>
              </el-table-column>
              <el-table-column label="开票备注" align="center" prop="开票备注">
                <template slot-scope="scope">
                  <span>{{ scope.row.invoiceRemark }}</span>
                </template>
              </el-table-column>
              <el-table-column label="税号" align="center" prop="税号">
                <template slot-scope="scope">
                  <span>{{ scope.row.invoiceCode }}</span>
                </template>
              </el-table-column>
              <el-table-column label="开票单位" align="center" prop="开票单位">
                <template slot-scope="scope">
                  <span>{{ scope.row.invoiceConpayName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="点单数" align="center" prop="点单数">
                <template slot-scope="scope">
                  <span>{{ scope.row.orderMenuCount }}</span>
                </template>
              </el-table-column>
              <el-table-column label="离开时间" align="center" prop="离开时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.leaveTime | dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="账单打印次数"
                align="center"
                prop="账单打印次数"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.billPrintCount }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="机构代码" align="center"  prop="机构代码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.branchCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column label="机构名称" align="center" prop="机构名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.branchName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="下单日期" align="center" prop="下单日期">
                <template slot-scope="scope">
                  <span>{{ scope.row.orderDt | dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="微信openId"
                align="center"
                prop="微信openId"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.openId }}</span>
                </template>
              </el-table-column>
              <el-table-column label="订单来源" align="center" prop="订单来源">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.sourceCode }}</span> -->
                  <span v-if="scope.row.sourceCode == 'cashier'">收银</span>
                  <span v-if="scope.row.sourceCode == 'wap'">网页</span>
                  <span v-if="scope.row.sourceCode == 'mini'">微信小程序</span>
                  <span v-if="scope.row.sourceCode == 'ele'">饿了么</span>
                  <span v-if="scope.row.sourceCode == 'meituan'">美团</span>
                </template>
              </el-table-column>
              <el-table-column
                label="订单来源名称"
                align="center"
                prop="订单来源名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.sourceName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="同步状态" align="center" prop="同步状态">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.syncStatus }}</span> -->
                  <span v-if="scope.row.syncStatus == 1">已同步</span>
                  <span v-if="scope.row.syncStatus == 2">未同步</span>
                </template>
              </el-table-column>
              <el-table-column label="同步日期" align="center" prop="同步日期">
                <template slot-scope="scope">
                  <span>{{ scope.row.syncDt | dataFormat }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="营业账期" align="center"  prop="营业账期" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.businessDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="折扣方案编码" align="center"  prop="折扣方案编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.discountPlanCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="折扣方案名称" align="center"  prop="折扣方案名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.discountPlanName }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column label="班次名称" align="center"  prop="班次名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.shiftCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column label="班次名称" align="center" prop="班次名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.shiftName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="配送类型" align="center" prop="配送类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.deliveryType }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="线上点单人员编码" align="center"  prop="线上点单人员编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.onlineUserCode }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column label="线上点单人头像" align="center"  prop="线上点单人头像" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.onlineUserLogo }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="线上点单人昵称"
                align="center"
                prop="线上点单人昵称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.onlineUserName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="收货信息" align="center" prop="收货信息">
                <template slot-scope="scope">
                  <span>{{ scope.row.distributor }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收货人联系号码/提货人联系号码"
                align="center"
                prop="收货人联系号码/提货人联系号码"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.distributorPhone }}</span>
                </template>
              </el-table-column>
              <el-table-column label="收货日期" align="center" prop="收货日期">
                <template slot-scope="scope">
                  <span>{{ scope.row.distributDt | dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column label="接单状态" align="center" prop="接单状态">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.receiptStatus }}</span> -->
                  <span v-if="scope.row.receiptStatus == 0">待接单</span>
                  <span v-if="scope.row.receiptStatus == 1">已接单</span>
                  <span v-if="scope.row.receiptStatus == 2">已拒单</span>
                  <span v-if="scope.row.receiptStatus == 3">已完成</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="接单人编码" align="center"  prop="接单人编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.receiptPersonCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="接单人名称"
                align="center"
                prop="接单人名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.receiptPersonName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="接单时间" align="center" prop="接单时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.receiptDt }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="店家拒绝原因"
                align="center"
                prop="店家拒绝原因"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.refuseReason }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="线上订单状态"
                align="center"
                prop="线上订单状态"
              >
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.orderStatus }}</span> -->
                  <span v-if="scope.row.orderStatus == 0">已下单</span>
                  <span v-if="scope.row.orderStatus == 1">已付款</span>
                </template>
              </el-table-column>
              <el-table-column label="完成时间" align="center" prop="完成时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.finishDt | dataFormat }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="完成操作人编码" align="center"  prop="完成操作人编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.finishPersonCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="完成操作人名称"
                align="center"
                prop="完成操作人名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.finishPersonName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="订单类型" align="center" prop="订单类型">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.orderType }}</span> -->
                  <span v-if="scope.row.orderType == 'offline'">线下订单</span>
                  <span v-if="scope.row.orderType == 'online'">线上订单</span>
                </template>
              </el-table-column>
              <el-table-column label="含税价" align="center" prop="含税价">
                <template slot-scope="scope">
                  <span>{{ scope.row.containTaxPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column label="含税金额" align="center" prop="含税金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.containTaxSum }}</span>
                </template>
              </el-table-column>
              <el-table-column label="税额" align="center" prop="税额">
                <template slot-scope="scope">
                  <span>{{ scope.row.taxSum }}</span>
                </template>
              </el-table-column>
              <el-table-column label="成本均价" align="center" prop="成本均价">
                <template slot-scope="scope">
                  <span>{{ scope.row.costAvgPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column label="成本金额" align="center" prop="成本金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.costSum }}</span>
                </template>
              </el-table-column>
              <el-table-column label="毛利" align="center" prop="毛利">
                <template slot-scope="scope">
                  <span>{{ scope.row.grossProfit }}</span>
                </template>
              </el-table-column>
              <el-table-column label="毛利率" align="center" prop="毛利率">
                <template slot-scope="scope">
                  <span>{{ scope.row.grossProfitRate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="销售比重" align="center" prop="销售比重">
                <template slot-scope="scope">
                  <span>{{ scope.row.saleWeight }}</span>
                </template>
              </el-table-column>
              <el-table-column label="毛利比重" align="center" prop="毛利比重">
                <template slot-scope="scope">
                  <span>{{ scope.row.grossProfitWeight }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="是否进行反结账"
                align="center"
                prop="是否进行反结账"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.isCorrect }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="反结账时间"
                align="center"
                prop="反结账时间"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.correctDt | dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="反结账原因"
                align="center"
                prop="反结账原因"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.correctReason }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="反结账操作人编码" align="center"  prop="反结账操作人编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.correctUserCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="反结账操作人员"
                align="center"
                prop="反结账操作人员"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.correctUserName }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="连锁编码" align="center"  prop="连锁编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.groupCode }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column label="连锁名称" align="center" prop="连锁名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.groupName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="微信订单号"
                align="center"
                prop="微信订单号"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.wechatOrderNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="收货人姓名/提货人姓名"
                align="center"
                prop="收货人姓名/提货人姓名"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.distributorName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="收货地址" align="center" prop="收货地址">
                <template slot-scope="scope">
                  <span>{{ scope.row.distributorAddress }}</span>
                </template>
              </el-table-column>
              <el-table-column label="差价" align="center" prop="差价">
                <template slot-scope="scope">
                  <span>{{ scope.row.balanceAmount }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="补差支付方式" align="center"  prop="补差支付方式" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.balancePayType }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.balancePayDt }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column
                label="关联订单号"
                align="center"
                prop="关联订单号"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.balanceRelativeOrder }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.backTranNo }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="支付通道" align="center"  prop="支付通道" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.payChannel }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="订单备注" align="center"  prop="订单备注" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.orderRemark }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否参与分账" align="center"  prop="是否参与分账" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.isJoinProfitSharing }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="分账类型" align="center"  prop="分账类型" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.profitSharingType }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.backDt }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否调用分账" align="center"  prop="是否调用分账" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.isProfitSharing }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="分账调用时间" align="center"  prop="分账调用时间" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.profitSharingDt }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="分账金额" align="center"  prop="分账金额" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.profitSharingAmount }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column
                label="操作"
                align="center"
                class-name="small-padding fixed-width"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="编辑"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-edit textblue f16"
                      @click="gotoDetail(scope.row.id, scope.row.userCode)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-delete textblue f16 ml20"
                      @click="del(scope.row.id)"
                    ></i>
                  </el-tooltip>
                </template>
              </el-table-column> -->
            </el-table>
          </el-row></el-scrollbar
        >
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      topDate: {
        aliCount: "0.00",
        weChatCount: "0.00",
        bankCount: "0.00",
        memberCardCount: "0.00",
        cashierCount: "0.00",
        otherCount: "0.00"
      },
      orderDate: [],
      options: [
        {
          label: "支付宝",
          value: "alipay"
        },
        {
          label: "微信",
          value: "wechat"
        },
        {
          label: "银行卡",
          value: "bank"
        },
        {
          label: "会员卡",
          value: "memberCard"
        },
        {
          label: "现金",
          value: "cashier"
        }
      ],
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          id: ""
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: ""
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false
    };
  },
  created() {
    this.queryInfo.currPage = this.$route.query.currPage;
    this.queryInfo.pageSize = this.$route.query.pageSize;
    this.getListData();
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
    this.getTopDate();
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    // 获取顶部金额
    getTopDate() {
      var that = this;
      let params = localStorage.getItem("merchantCode");
      that.$http
        .post("/merchantOrders/getCountByPay", { merchantCode: params })
        .then(res => {
          console.log(res.data, "dataTop");
          if (res.data.code == 200) {
            this.topDate = res.data.data;
          }
        });
    },
    //获取时间
    getOrderDate() {
      if (this.orderDate.length > 0) {
        this.queryInfo.condition.startDate = this.orderDate[0];
        this.queryInfo.condition.endDate = this.orderDate[1];
      } else {
        this.queryInfo.condition.startDate = "";
        this.queryInfo.condition.endDate = "";
      }
    },
    //条件查询
    search() {
      var that = this;

      // this.queryInfo.condition.id = this.searchInput;
      if (that.orderDate != null && that.orderDate.length > 0) {
        that.queryInfo.condition.startDate = that.orderDate[0];
        that.queryInfo.condition.endDate = that.orderDate[1];
      } else {
        that.queryInfo.condition.startDate = "";
        that.queryInfo.condition.endDate = "";
      }
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/merchantOrder/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize
        }
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantOrder/delete", { id: id })
          .then(function(response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      that.queryInfo.condition.merchantCode = localStorage.getItem(
        "merchantCode"
      );
      that.$http
        .post("/merchantOrders/list", that.queryInfo)
        .then(function(response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    }
  }
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
/deep/.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 100% !important;
}
</style>
